// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"bbab1fe1","453":"2242a791","498":"208c0d49","551":"50535b9b","572":"67792d0f","838":"ff90fdae","950":"a7b1bfb3"}[chunkId] + ".chunk.js";
};